<div class="ir-area ir-mask th-mask" [open]="!isOpen" [attr.data-keyboard]="true" [attr.data-backdrop]="false">
  <div class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line--right">
        <div class="ir-btn th-btn-modal" (click)="openMenu()"><i class="material-icons">more_vert</i></div>
      </div>
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ title }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content" style="height: 100%">
        <ng-container *ngIf="contentType === contentTypes?.image">
          <img *ngIf="assetUrl" [src]="assetUrl" width="100%" />
          <img *ngIf="content" [src]="content" width="100%" />
          <img *ngIf="fileBox" [src]="getFileBoxUrl(fileBox)" width="100%" />
        </ng-container>
        <ng-container *ngIf="contentType === contentTypes?.pdf">
          <iframe *ngIf="assetUrl" [src]="assetUrl" type="application/pdf" width="100%" height="100%"></iframe>
          <iframe *ngIf="content" [src]="content" type="application/pdf" width="100%" height="100%"></iframe>
          <iframe
            *ngIf="fileBox"
            [src]="getFileBoxUrl(fileBox)"
            type="application/pdf"
            width="100%"
            height="100%"
          ></iframe>
        </ng-container>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6" *ngIf="closeButton">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="close()">
            <span>{{ cancelButtonText }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6" (click)="submit()">
          <button class="ir-btn ir-btn--big ir-btn--block ir-txt--right th-btn-modal--action">
            <span>{{ okButtonText }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
